import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Badge } from 'baby-design'
import { BadgeFill } from 'baby-design/components/Badge/Badge.types'

import { CurrentState } from 'src/types/shipments'
import { ShipmentStatusSummary } from 'src/types/reservation'

import { formatMonthDate } from '../../utils'

const badgeColors: Record<
  NonNullable<Exclude<CurrentState, 'unknown'>>,
  BadgeFill
> = {
  processing: 'gray',
  preparing: 'gray',
  shipped: 'blue',
  delivered: 'green',
  cancelled: 'discount-ruby',
}

export const shipmentBadgeColor = (
  currentState: NonNullable<Exclude<CurrentState, 'unknown'>>
) => badgeColors[currentState]

const formatCurrentState = (currentState: string) =>
  currentState.charAt(0).toUpperCase() + currentState.slice(1)

const badgeLabel = ({
  currentStateDisplay,
  relevantDate,
}: ShipmentStatusSummary) =>
  `${formatCurrentState(currentStateDisplay)} ${formatMonthDate(relevantDate)}`

const ShipmentStatusSummaryBadge: FC<{
  shipmentStatusSummary: ShipmentStatusSummary | null | undefined
}> = ({ shipmentStatusSummary }) => {
  if (!shipmentStatusSummary) {
    return null
  }
  const { currentState } = shipmentStatusSummary

  if (!currentState || currentState === 'unknown') {
    return null
  }

  return (
    <Badge
      fill={shipmentBadgeColor(currentState)}
      label={badgeLabel(shipmentStatusSummary)}
      size="medium"
      variant="general"
    />
  )
}

export default ShipmentStatusSummaryBadge
